import { View } from 'ol';

export const createCountryView = (): View => {
  return new View({
    center: [0, 0],
    enableRotation: false,
    extent: [-210, -90, 210, 90] as [number, number, number, number],
    maxZoom: 18,
    minZoom: 0,
    zoom: 1,
    projection: 'EPSG:4326',
  });
};
